const config = {
  API_URL: process.env.REACT_APP_API_URL,
  EVALUACION_URL: process.env.REACT_APP_EVALUACION_URL,
};

export default config;
